"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    '__firefox__',
    'BetterJsPop',
    'Failed to execute.*Node',
    'IE Intranet mode',
    'Illegal invocation',
    'Invalid site key or not loaded in api',
    'Netzwerkverbindung.*unterbrochen',
    'No response from window',
    'No value passed to payment',
    'Please load Stripe',
    'URIError.*recaptcha|recaptcha.*is not accessible',
    'Stripe.js requires that your page has a <body>',
    'Window closed',
    'Window not found on which to reject sendMessage',
    'Zeitüberschreitung',
    'Zugriff verweigert',
    'avast',
    'cannot redefine.*googletag',
    'closingEls',
    'could not retrieve data from the specified Element',
    'kaspersky',
    'network error',
    'non-configurable property .*userAgent',
    'pktAnnotationHighlighter',
    'postMessage zoid_init',
    'postrobot',
    'tgetT is not defined',
    'translate.googleusercontent.com',
    'webkitExitFullScreen',
    'xoplatform/logger',
    'ztePageScrollModule',
    'TypeError.*null is not an object.*evaluating',
    'Detected container element removed from DOM',
    'Object Not Found Matching Id:', // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/13
];
//# sourceMappingURL=ignoredMessages.js.map